module.exports = __webpack_public_path__ + "media/images/avatar/30-51dd801528c8e9543df99eecfd04b964.svg";